import { Divider, InputAdornment, TextField } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useMutation } from "react-query";
import { KTCard } from "../../_metronic/helpers";
import {
  getDefaultCommission,
  getYoutubeUrl,
  updateDefaultCommission,
  updateYoutubeUrl,
} from "../../api";
import { snackActions } from "../../helpers/SnackUtilsConfigurator";

// import AddEditUser from "./AddEditUser";

const AppConfig: React.FC = () => {
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [commission, setCommission] = useState("");
  const [commissionError, setCommissionError] = useState("");
  const [youtubeError, setYoutubeError] = useState("");

  const handleUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setYoutubeUrl(event.target.value);
  };

  const handleCommissionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    //Allow clearing (temporary empty) but mark as invalid
    if (value === "") {
      setCommission("");
      setCommissionError("Commission is required.");
      return;
    }

    //Block % or any non-numeric input (we use regex later, but early block helps)
    if (value.includes("%")) {
      return; // Ignore
    }

    //Regex: Max 3 digits before decimal, max 2 after
    const regex = /^(?!0\d)\d{1,3}(\.\d{1,2})?$/;

    const partialRegex = /^\d{1,3}\.$/;

    if (!regex.test(value) && !partialRegex.test(value)) {
      return; // Reject invalid format
    }

    const numValue = parseFloat(value);

    if (isNaN(numValue)) {
      setCommissionError("Invalid number");
      return;
    }

    //Final Validation
    if (numValue <= 0) {
      setCommissionError("Commission must be greater than 0.");
      return;
    }

    if (numValue > 20.0) {
      setCommissionError("Commission cannot exceed 20.0");
      return;
    }

    //All valid
    setCommission(value);
    setCommissionError("");
  };

  const {
    mutateAsync: getYoutubeUrlData,
    data: YoutubeUrlData,
    isLoading: isGetYoutubeUrl,
  } = useMutation(getYoutubeUrl);

  const {
    mutateAsync: getCommissionData,
    data: CommissionData,
    isLoading: isGetCommission,
  } = useMutation(getDefaultCommission);

  const { mutateAsync: updateUrl, isLoading: isUpdatingUrl } = useMutation(
    "update-url",
    updateYoutubeUrl,
  );

  const { mutateAsync: updateCommission, isLoading: isUpdatingCommission } =
    useMutation("update-commission", updateDefaultCommission);

  const handleSubmit = useCallback(async () => {
    let bodyParams = {
      id: YoutubeUrlData?.result?.id,
      key: "Youtube_URL",
      value: youtubeUrl,
      description: null,
    };

    let updateCommissionPayload = {
      id: CommissionData?.result?.id,
      key: "Default_PlatformFee_Percentage",
      value: commission,
      description: null,
    };

    let response = await updateUrl(bodyParams);

    let commissionResponse = await updateCommission(updateCommissionPayload);

    if (response?.result) {
      if (commissionResponse?.result) {
        snackActions.success("App Config Updated Successfully!");
      }
    } else {
      snackActions.error(response?.message ?? "Something went wrong!");
    }
  }, [
    CommissionData?.result?.id,
    YoutubeUrlData?.result?.id,
    commission,
    updateCommission,
    updateUrl,
    youtubeUrl,
  ]);

  useEffect(() => {
    getYoutubeUrlData({});
    getCommissionData({});
  }, [getCommissionData, getYoutubeUrlData]);

  useEffect(() => {
    YoutubeUrlData && setYoutubeUrl(YoutubeUrlData?.result?.value);
    CommissionData && setCommission(CommissionData?.result?.value);
    console.log("YoutubeUrlData", YoutubeUrlData);
    console.log("CommissionData", CommissionData);
  }, [CommissionData, YoutubeUrlData]);

  return (
    <Card className="p-6">
      <>
        <KTCard>
          <h3 style={{ position: "absolute", top: "5px" }}>
            Add / Update App Config :
          </h3>

          <div style={{ marginTop: "50px", display: "flex", gap: "10px" }}>
            <TextField
              label="Enter YouTube URL"
              variant="outlined"
              fullWidth
              value={youtubeUrl}
              onChange={handleUrlChange}
            />
          </div>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              gap: "10px",
            }}
          >
            <TextField
              label="Enter Default Commission"
              variant="outlined"
              fullWidth
              value={commission}
              onChange={handleCommissionChange}
              error={!!commissionError} // Highlights the field in red if there's an error
              helperText={
                commissionError ||
                "Enter a value greater than 0 and up to 20.00"
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <span style={{ fontWeight: 500, color: "#555" }}>%</span>
                  </InputAdornment>
                ),
              }}
              type="text" // Use "text" to have full control over formatting
              inputProps={{
                inputMode: "decimal", // Shows numeric keypad on mobile
                "aria-label": "Commission input",
              }}
            />
          </div>

          <div className="d-flex justify-content-between">
            <Button
              disabled={isUpdatingUrl}
              variant="success"
              style={{
                width: "100px",
                marginLeft: "auto",
                marginBottom: "10px",
                marginTop: "25px",
              }}
              onClick={handleSubmit}
            >
              {isUpdatingUrl ? "Loading.." : "Submit"}
            </Button>
          </div>

          <Divider style={{ marginBottom: "20px", marginTop: "20px" }} />
        </KTCard>
      </>
    </Card>
  );
};

export default AppConfig;
